import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import './calendar.css'
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { format } from "date-fns";
import NavBar from '../components/Home/NavBar';
import { CreateTurno, RestablecerTurnos, SacarTurno, SacarTurnosDelDia, getTurnosDisponibles } from '../actions';
import Swal from 'sweetalert2'


Modal.setAppElement('#root');

const Turnero = (): JSX.Element => {
  
  const dispatch = useDispatch();

  const fechasDisponibles =useSelector((state:any)=>state.turnosDisponibles)
  const [selectedDate, setSelectedDate] = useState<Date | any>(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [turno,setTurno] = useState<{} | any>(null)
  const [actualizar,setActualizar] = useState(false)
  const horaActual=getCurrentTime()


  const token = localStorage.getItem("token")
  const rol = localStorage.getItem("rol")

  function calcularEndTime(initTime: string): string | null {
    const initTimeIndex = fechasDisponibles.indexOf(initTime);
    if (initTimeIndex !== -1 && initTimeIndex + 1 < fechasDisponibles.length) {
      const initDate = new Date(`2000-01-01T${initTime}`);
      const endDate = new Date(initDate.getTime() + 20 * 60000); // Suma 20 minutos en milisegundos
      const endHours = String(endDate.getHours()).padStart(2, '0');
      const endMinutes = String(endDate.getMinutes()).padStart(2, '0');
      return `${endHours}:${endMinutes}`;
    } else {
      return null;
    }
  }
  function getCurrentTime() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  useEffect(() => {
    if (selectedDate!=null || actualizar===true) {
        dispatch(getTurnosDisponibles(format(selectedDate, 'dd/MM/yyyy')));
        setActualizar(false)
    }
  }, [turno,actualizar]); 

  function handleDateClick(value: Date): void {
    const fecha=format(value, 'dd/MM/yyyy')
    
    dispatch(getTurnosDisponibles(fecha))
    setSelectedDate(value);
    setModalIsOpen(true);
  } 

  const handleCancelarTurnosDia=async(date:any)=>{
    date=format(date, 'dd/MM/yyyy')
    await dispatch(SacarTurnosDelDia(date,token))
    setActualizar(true)
  }
  const handleRestablecer=async(date:any)=>{
    date=format(date, 'dd/MM/yyyy')
    await dispatch(RestablecerTurnos(date,token))
    setActualizar(true)
  }
  const handleCancelarTurno=async(input:any)=>{
    await dispatch(SacarTurno(input,token))
    setActualizar(true)
  }

  const handleAgendar = (turno: {}) => {
    Swal.fire({
      title: '¿Estás seguro de que deseas sacar este turno?',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      icon: 'question'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(CreateTurno(turno, token));
        setTurno(turno);
        Swal.fire('¡Turno reservado!', '', 'success');
      }
    })
  };

  type TileArgs = {
    date: Date;
    view: string;
  };
  
  type TileDisabledFunc = ({ date, view }: TileArgs) => boolean;

  const disableWeekends: TileDisabledFunc = ({ date }:{date:Date}) => {
    const day = date.getDay();
    return day === 0 || day === 6;
  };

  const handleModalClose = (): void => {
    setModalIsOpen(false);
  };

  const date = new Date();
  
  return (
    <div className='flex bg-bgSteps h-screen flex-col items-center'>
      <NavBar/>
    {token ? <div className='flex h-screen flex-col items-center' >
      
       <div className='mt-4 mb-16 sm:mb-24'>
      <h1 className='font-roboto text-[32px] sm:text-[42px]'>Reservar turnos</h1>
    </div>   

     <div className='w-screen sm:w-auto'>
      <Calendar
        onClickDay={handleDateClick}
        minDate={date}
        tileDisabled={disableWeekends} // aquí se pasa la función
        />
        </div>

        <Modal
  className='w-4/5 sm:w-2/4 bg-white'
  isOpen={modalIsOpen}
  onRequestClose={handleModalClose}
  style={{
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    content: {
      position: 'relative',
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      border: 'none',
      borderRadius: '10px',
      padding: '20px',
      maxWidth: '90%',
      maxHeight: '90%',
    },
  }}
>
  {selectedDate && (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className='flex justify-center flex-col items-center'>
        <h2 className=' text-[20px] sm:text-[28px] font-roboto'>
          Turnos disponibles para el {format(selectedDate, 'dd/MM/yyyy')}
        </h2>
        <ul className='flex flex-row items-center justify-center flex-wrap'>
        {fechasDisponibles &&
  fechasDisponibles
    .map((d: any, index: number) => {
      const endTime = calcularEndTime(d);
      if (!endTime) return null;
      return (
        <li key={index}>
          <div className='flex flex-col gap-2 items-center justify-center border text-[12px]  sm:text-[12px] ml-2 mt-2 p-2 rounded-xl font-roboto border-black'>
            {/* <div>
              Fecha: {format(selectedDate, 'dd/MM/yyyy')}
            </div> */}
            <div>
              Horario: {d} - {endTime}
            </div>
            <div>
              <button
                className='bg-background_home rounded-md w-12 h-4 sm:w-24 sm:h-6 sm:text-[10px] text-[10px] font-roboto text-white'
                onClick={() => handleAgendar({
                  date:format(selectedDate, 'dd/MM/yyyy'),
                  initTime:d,
                  endTime:endTime
                })}
              >
                Agendar
              </button>
              {rol==="admin"&&
              <button
                className='bg-background_home rounded-md w-12 h-4 sm:w-24 sm:h-6 sm:text-[10px] text-[10px] font-roboto text-white'
                onClick={() => handleCancelarTurno({
                  date:format(selectedDate, 'dd/MM/yyyy'),
                  initTime:d,
                  endTime:endTime
                })}
              >
                Cancelar
              </button>
              }
            </div>
          </div>
        </li>
      );
    })}
        </ul>
      </div>
    </div>
  )}
  {rol==="admin"&&
  <div>
  <button className='w-24 rounded-xl h-8 mt-8 bg-red-600 text-white' onClick={()=>handleCancelarTurnosDia(selectedDate)}>
    Cancelar turnos del día
  </button>
  <button className='w-24 rounded-xl h-8 mt-8 bg-red-600 text-white' onClick={()=>handleRestablecer(selectedDate)}>
    Restablecer turnos del día
  </button>
  </div>
  }
  <button className='w-24 rounded-xl h-8 mt-8 bg-red-600 text-white' onClick={handleModalClose}>
    Cerrar
  </button>
</Modal>
 </div> 

: <p className='font-roboto text-[24px]'>Debes iniciar Sesion para poder utilizar esta ventana </p>}
    
    </div>
  );
};

export default Turnero;
